// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Importing the Google Fonts 'Open Sans' with multiple weights for the body text
 */
 /* @import url('https://fonts.google.com/share?selection.family=Inter:wght@100..900'); */
 /* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap'); */
 /**
  * Resetting default margin and padding for the body
  * Setting the font family for the entire document to 'Inter', falling back to the default sans-serif font
  */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
 body {
     margin: 0;
     padding: 0;
     font-family: "Inter" , "sans-serif";
 }
 
 /**
  * Importing Tailwind CSS base, components, and utilities
  */
 *, ::before, ::after{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
 ::backdrop{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
 /*! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
 */
 /*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
 *,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
 ::before,
::after {
  --tw-content: '';
}
 /*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
 html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
 /*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
 body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
 /*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
 hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
 /*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
 abbr:where([title]) {
  text-decoration: underline dotted;
}
 /*
Remove the default font size and weight for headings.
*/
 h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
 /*
Reset links to optimize for opt-in styling instead of opt-out.
*/
 a {
  color: inherit;
  text-decoration: inherit;
}
 /*
Add the correct font weight in Edge and Safari.
*/
 b,
strong {
  font-weight: bolder;
}
 /*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
 code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
 /*
Add the correct font size in all browsers.
*/
 small {
  font-size: 80%;
}
 /*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
 sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
 sub {
  bottom: -0.25em;
}
 sup {
  top: -0.5em;
}
 /*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
 table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
 /*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
 button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
 /*
Remove the inheritance of text transform in Edge and Firefox.
*/
 button,
select {
  text-transform: none;
}
 /*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
 button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
 /*
Use the modern Firefox focus style for all focusable elements.
*/
 :-moz-focusring {
  outline: auto;
}
 /*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
 :-moz-ui-invalid {
  box-shadow: none;
}
 /*
Add the correct vertical alignment in Chrome and Firefox.
*/
 progress {
  vertical-align: baseline;
}
 /*
Correct the cursor style of increment and decrement buttons in Safari.
*/
 ::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
 /*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
 [type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
 /*
Remove the inner padding in Chrome and Safari on macOS.
*/
 ::-webkit-search-decoration {
  -webkit-appearance: none;
}
 /*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
 ::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
 /*
Add the correct display in Chrome and Safari.
*/
 summary {
  display: list-item;
}
 /*
Removes the default spacing and border for appropriate elements.
*/
 blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
 fieldset {
  margin: 0;
  padding: 0;
}
 legend {
  padding: 0;
}
 ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
 /*
Reset default styling for dialogs.
*/
 dialog {
  padding: 0;
}
 /*
Prevent resizing textareas horizontally by default.
*/
 textarea {
  resize: vertical;
}
 /*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
 input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
 /*
Set the default cursor for buttons.
*/
 button,
[role="button"] {
  cursor: pointer;
}
 /*
Make sure disabled buttons don't get the pointer cursor.
*/
 :disabled {
  cursor: default;
}
 /*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
 img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
 /*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
 img,
video {
  max-width: 100%;
  height: auto;
}
 /* Make elements with the HTML hidden attribute stay hidden by default */
 [hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
 .sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
 .pointer-events-none{
    pointer-events: none;
}
 .visible{
    visibility: visible;
}
 .fixed{
    position: fixed;
}
 .absolute{
    position: absolute;
}
 .relative{
    position: relative;
}
 .sticky{
    position: sticky;
}
 .inset-0{
    inset: 0px;
}
 .inset-y-0{
    top: 0px;
    bottom: 0px;
}
 .\\!right-\\[3px\\]{
    right: 3px !important;
}
 .-right-0{
    right: -0px;
}
 .-right-0\\.5{
    right: -0.125rem;
}
 .-right-1{
    right: -0.25rem;
}
 .-right-16{
    right: -4rem;
}
 .-right-27{
    right: -6.75rem;
}
 .-top-0\\.5{
    top: -0.125rem;
}
 .-top-1{
    top: -0.25rem;
}
 .bottom-0{
    bottom: 0px;
}
 .bottom-1{
    bottom: 0.25rem;
}
 .bottom-3{
    bottom: 0.75rem;
}
 .bottom-full{
    bottom: 100%;
}
 .left-0{
    left: 0px;
}
 .left-1{
    left: 0.25rem;
}
 .left-3{
    left: 0.75rem;
}
 .left-4{
    left: 1rem;
}
 .left-7{
    left: 1.75rem;
}
 .left-\\[3px\\]{
    left: 3px;
}
 .right-0{
    right: 0px;
}
 .right-1{
    right: 0.25rem;
}
 .right-18{
    right: 4.5rem;
}
 .right-2{
    right: 0.5rem;
}
 .right-3{
    right: 0.75rem;
}
 .top-0{
    top: 0px;
}
 .top-1{
    top: 0.25rem;
}
 .top-1\\/2{
    top: 50%;
}
 .top-2{
    top: 0.5rem;
}
 .top-20{
    top: 5rem;
}
 .top-3{
    top: 0.75rem;
}
 .top-full{
    top: 100%;
}
 .-z-1{
    z-index: -1;
}
 .z-1{
    z-index: 1;
}
 .z-10{
    z-index: 10;
}
 .z-20{
    z-index: 20;
}
 .z-50{
    z-index: 50;
}
 .z-999{
    z-index: 999;
}
 .z-\\[10000\\]{
    z-index: 10000;
}
 .z-\\[1000\\]{
    z-index: 1000;
}
 .col-span-2{
    grid-column: span 2 / span 2;
}
 .col-span-3{
    grid-column: span 3 / span 3;
}
 .m-0{
    margin: 0px;
}
 .m-1{
    margin: 0.25rem;
}
 .m-10{
    margin: 2.5rem;
}
 .m-2{
    margin: 0.5rem;
}
 .m-3{
    margin: 0.75rem;
}
 .m-4{
    margin: 1rem;
}
 .m-5{
    margin: 1.25rem;
}
 .m-9{
    margin: 2.25rem;
}
 .m-\\[0\\.5\\%\\]{
    margin: 0.5%;
}
 .m-auto{
    margin: auto;
}
 .mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
}
 .mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
}
 .mx-auto{
    margin-left: auto;
    margin-right: auto;
}
 .my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
}
 .-mb-16{
    margin-bottom: -4rem;
}
 .-mb-4{
    margin-bottom: -1rem;
}
 .-mb-5{
    margin-bottom: -1.25rem;
}
 .-mb-px{
    margin-bottom: -1px;
}
 .-ml-2{
    margin-left: -0.5rem;
}
 .-ml-\\[1\\%\\]{
    margin-left: -1%;
}
 .-mr-10{
    margin-right: -2.5rem;
}
 .-mt-3{
    margin-top: -0.75rem;
}
 .-mt-4{
    margin-top: -1rem;
}
 .-mt-6{
    margin-top: -1.5rem;
}
 .-mt-9{
    margin-top: -2.25rem;
}
 .mb-0{
    margin-bottom: 0px;
}
 .mb-1{
    margin-bottom: 0.25rem;
}
 .mb-2{
    margin-bottom: 0.5rem;
}
 .mb-20{
    margin-bottom: 5rem;
}
 .mb-3{
    margin-bottom: 0.75rem;
}
 .mb-4{
    margin-bottom: 1rem;
}
 .mb-5{
    margin-bottom: 1.25rem;
}
 .mb-6{
    margin-bottom: 1.5rem;
}
 .mb-8{
    margin-bottom: 2rem;
}
 .mb-\\[2px\\]{
    margin-bottom: 2px;
}
 .ml-1{
    margin-left: 0.25rem;
}
 .ml-2{
    margin-left: 0.5rem;
}
 .ml-3{
    margin-left: 0.75rem;
}
 .ml-4{
    margin-left: 1rem;
}
 .ml-5{
    margin-left: 1.25rem;
}
 .ml-56{
    margin-left: 14rem;
}
 .ml-9{
    margin-left: 2.25rem;
}
 .ml-96{
    margin-left: 24rem;
}
 .ml-\\[5\\%\\]{
    margin-left: 5%;
}
 .ml-auto{
    margin-left: auto;
}
 .mr-1{
    margin-right: 0.25rem;
}
 .mr-10{
    margin-right: 2.5rem;
}
 .mr-13{
    margin-right: 3.25rem;
}
 .mr-2{
    margin-right: 0.5rem;
}
 .mr-3{
    margin-right: 0.75rem;
}
 .mr-4{
    margin-right: 1rem;
}
 .mr-5{
    margin-right: 1.25rem;
}
 .mr-\\[5\\%\\]{
    margin-right: 5%;
}
 .mt-0{
    margin-top: 0px;
}
 .mt-1{
    margin-top: 0.25rem;
}
 .mt-10{
    margin-top: 2.5rem;
}
 .mt-2{
    margin-top: 0.5rem;
}
 .mt-2\\.5{
    margin-top: 0.625rem;
}
 .mt-3{
    margin-top: 0.75rem;
}
 .mt-4{
    margin-top: 1rem;
}
 .mt-5{
    margin-top: 1.25rem;
}
 .mt-6{
    margin-top: 1.5rem;
}
 .mt-8{
    margin-top: 2rem;
}
 .mt-\\[0\\.7\\%\\]{
    margin-top: 0.7%;
}
 .mt-\\[20\\%\\]{
    margin-top: 20%;
}
 .mt-\\[5\\%\\]{
    margin-top: 5%;
}
 .mt-\\[o\\.5\\%\\]{
    margin-top: o.5%;
}
 .line-clamp-1{
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
 .block{
    display: block;
}
 .inline-block{
    display: inline-block;
}
 .inline{
    display: inline;
}
 .flex{
    display: flex;
}
 .inline-flex{
    display: inline-flex;
}
 .table{
    display: table;
}
 .grid{
    display: grid;
}
 .hidden{
    display: none;
}
 .aspect-video{
    aspect-ratio: 16 / 9;
}
 .h-0{
    height: 0px;
}
 .h-1\\.5{
    height: 0.375rem;
}
 .h-10{
    height: 2.5rem;
}
 .h-100{
    height: 25rem;
}
 .h-11{
    height: 2.75rem;
}
 .h-12{
    height: 3rem;
}
 .h-12\\.5{
    height: 3.125rem;
}
 .h-13{
    height: 3.25rem;
}
 .h-14{
    height: 3.5rem;
}
 .h-16{
    height: 4rem;
}
 .h-2{
    height: 0.5rem;
}
 .h-20{
    height: 5rem;
}
 .h-3{
    height: 0.75rem;
}
 .h-32{
    height: 8rem;
}
 .h-36{
    height: 9rem;
}
 .h-4{
    height: 1rem;
}
 .h-5{
    height: 1.25rem;
}
 .h-6{
    height: 1.5rem;
}
 .h-60{
    height: 15rem;
}
 .h-64{
    height: 16rem;
}
 .h-7{
    height: 1.75rem;
}
 .h-7\\.5{
    height: 1.875rem;
}
 .h-8{
    height: 2rem;
}
 .h-9{
    height: 2.25rem;
}
 .h-90{
    height: 22.5rem;
}
 .h-\\[100vh\\]{
    height: 100vh;
}
 .h-\\[350px\\]{
    height: 350px;
}
 .h-\\[45vh\\]{
    height: 45vh;
}
 .h-\\[50px\\]{
    height: 50px;
}
 .h-\\[51px\\]{
    height: 51px;
}
 .h-\\[56px\\]{
    height: 56px;
}
 .h-\\[57vh\\]{
    height: 57vh;
}
 .h-\\[60vh\\]{
    height: 60vh;
}
 .h-\\[65vh\\]{
    height: 65vh;
}
 .h-\\[70vh\\]{
    height: 70vh;
}
 .h-\\[75vh\\]{
    height: 75vh;
}
 .h-\\[80\\%\\]{
    height: 80%;
}
 .h-\\[80vh\\]{
    height: 80vh;
}
 .h-\\[82vh\\]{
    height: 82vh;
}
 .h-\\[85vh\\]{
    height: 85vh;
}
 .h-\\[87vh\\]{
    height: 87vh;
}
 .h-\\[90vh\\]{
    height: 90vh;
}
 .h-\\[calc\\(100vh-12rem\\)\\]{
    height: calc(100vh - 12rem);
}
 .h-auto{
    height: auto;
}
 .h-fit{
    height: fit-content;
}
 .h-full{
    height: 100%;
}
 .h-max{
    height: max-content;
}
 .h-screen{
    height: 100vh;
}
 .max-h-32{
    max-height: 8rem;
}
 .max-h-60{
    max-height: 15rem;
}
 .max-h-64{
    max-height: 16rem;
}
 .max-h-96{
    max-height: 24rem;
}
 .max-h-\\[300px\\]{
    max-height: 300px;
}
 .max-h-\\[80vh\\]{
    max-height: 80vh;
}
 .max-h-\\[84vh\\]{
    max-height: 84vh;
}
 .max-h-\\[85vh\\]{
    max-height: 85vh;
}
 .max-h-\\[90vh\\]{
    max-height: 90vh;
}
 .min-h-0{
    min-height: 0px;
}
 .min-h-\\[100px\\]{
    min-height: 100px;
}
 .min-h-\\[120px\\]{
    min-height: 120px;
}
 .min-h-\\[70vh\\]{
    min-height: 70vh;
}
 .min-h-full{
    min-height: 100%;
}
 .min-h-screen{
    min-height: 100vh;
}
 .w-0{
    width: 0px;
}
 .w-1\\.5{
    width: 0.375rem;
}
 .w-1\\/2{
    width: 50%;
}
 .w-1\\/3{
    width: 33.333333%;
}
 .w-1\\/6{
    width: 16.666667%;
}
 .w-10{
    width: 2.5rem;
}
 .w-100{
    width: 25rem;
}
 .w-11{
    width: 2.75rem;
}
 .w-12{
    width: 3rem;
}
 .w-12\\.5{
    width: 3.125rem;
}
 .w-14{
    width: 3.5rem;
}
 .w-16{
    width: 4rem;
}
 .w-18{
    width: 4.5rem;
}
 .w-2{
    width: 0.5rem;
}
 .w-20{
    width: 5rem;
}
 .w-26{
    width: 6.5rem;
}
 .w-28{
    width: 7rem;
}
 .w-3{
    width: 0.75rem;
}
 .w-32{
    width: 8rem;
}
 .w-36{
    width: 9rem;
}
 .w-4{
    width: 1rem;
}
 .w-40{
    width: 10rem;
}
 .w-44{
    width: 11rem;
}
 .w-48{
    width: 12rem;
}
 .w-5{
    width: 1.25rem;
}
 .w-56{
    width: 14rem;
}
 .w-6{
    width: 1.5rem;
}
 .w-62\\.5{
    width: 15.625rem;
}
 .w-64{
    width: 16rem;
}
 .w-65{
    width: 16.25rem;
}
 .w-70{
    width: 17.5rem;
}
 .w-75{
    width: 18.75rem;
}
 .w-8{
    width: 2rem;
}
 .w-96{
    width: 24rem;
}
 .w-\\[100\\%\\]{
    width: 100%;
}
 .w-\\[200\\.5px\\]{
    width: 200.5px;
}
 .w-\\[20rem\\]{
    width: 20rem;
}
 .w-\\[300px\\]{
    width: 300px;
}
 .w-\\[30vw\\]{
    width: 30vw;
}
 .w-\\[398px\\]{
    width: 398px;
}
 .w-\\[40\\%\\]{
    width: 40%;
}
 .w-\\[400px\\]{
    width: 400px;
}
 .w-\\[404px\\]{
    width: 404px;
}
 .w-\\[45vh\\]{
    width: 45vh;
}
 .w-\\[480px\\]{
    width: 480px;
}
 .w-\\[500px\\]{
    width: 500px;
}
 .w-\\[50vw\\]{
    width: 50vw;
}
 .w-\\[520px\\]{
    width: 520px;
}
 .w-\\[550px\\]{
    width: 550px;
}
 .w-\\[580px\\]{
    width: 580px;
}
 .w-\\[600px\\]{
    width: 600px;
}
 .w-\\[70vw\\]{
    width: 70vw;
}
 .w-\\[720px\\]{
    width: 720px;
}
 .w-\\[80\\%\\]{
    width: 80%;
}
 .w-\\[800px\\]{
    width: 800px;
}
 .w-\\[90\\%\\]{
    width: 90%;
}
 .w-\\[900px\\]{
    width: 900px;
}
 .w-\\[95\\%\\]{
    width: 95%;
}
 .w-\\[960px\\]{
    width: 960px;
}
 .w-fit{
    width: fit-content;
}
 .w-full{
    width: 100%;
}
 .min-w-0{
    min-width: 0px;
}
 .min-w-20{
    min-width: 5rem;
}
 .min-w-24{
    min-width: 6rem;
}
 .min-w-\\[100px\\]{
    min-width: 100px;
}
 .min-w-\\[140px\\]{
    min-width: 140px;
}
 .min-w-\\[160px\\]{
    min-width: 160px;
}
 .min-w-\\[43px\\]{
    min-width: 43px;
}
 .min-w-\\[50vw\\]{
    min-width: 50vw;
}
 .min-w-\\[80px\\]{
    min-width: 80px;
}
 .min-w-full{
    min-width: 100%;
}
 .max-w-2xl{
    max-width: 42rem;
}
 .max-w-32{
    max-width: 8rem;
}
 .max-w-40{
    max-width: 10rem;
}
 .max-w-48{
    max-width: 12rem;
}
 .max-w-4xl{
    max-width: 56rem;
}
 .max-w-64{
    max-width: 16rem;
}
 .max-w-7xl{
    max-width: 80rem;
}
 .max-w-\\[240px\\]{
    max-width: 240px;
}
 .max-w-\\[70\\%\\]{
    max-width: 70%;
}
 .max-w-\\[88vw\\]{
    max-width: 88vw;
}
 .max-w-\\[90vw\\]{
    max-width: 90vw;
}
 .max-w-\\[95vw\\]{
    max-width: 95vw;
}
 .max-w-full{
    max-width: 100%;
}
 .max-w-md{
    max-width: 28rem;
}
 .max-w-screen-lg{
    max-width: 1024px;
}
 .max-w-xl{
    max-width: 36rem;
}
 .max-w-xs{
    max-width: 20rem;
}
 .flex-1{
    flex: 1 1;
}
 .flex-shrink-0{
    flex-shrink: 0;
}
 .shrink{
    flex-shrink: 1;
}
 .flex-grow{
    flex-grow: 1;
}
 .table-auto{
    table-layout: auto;
}
 .table-fixed{
    table-layout: fixed;
}
 .border-collapse{
    border-collapse: collapse;
}
 .\\!translate-x-full{
    --tw-translate-x: 100% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
 .-translate-y-1\\/2{
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 .translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 .translate-x-full{
    --tw-translate-x: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 .-rotate-90{
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 .rotate-180{
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 .rotate-90{
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 .transform{
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 @keyframes ping{
    75%, 100%{
        transform: scale(2);
        opacity: 0;
    }
}
 .animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
 @keyframes pulse{
    50%{
        opacity: .5;
    }
}
 .animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
 @keyframes spin{
    to{
        transform: rotate(360deg);
    }
}
 .animate-spin{
    animation: spin 1s linear infinite;
}
 .cursor-help{
    cursor: help;
}
 .cursor-not-allowed{
    cursor: not-allowed;
}
 .cursor-pointer{
    cursor: pointer;
}
 .select-none{
    -webkit-user-select: none;
            user-select: none;
}
 .resize-none{
    resize: none;
}
 .resize{
    resize: both;
}
 .list-inside{
    list-style-position: inside;
}
 .list-decimal{
    list-style-type: decimal;
}
 .list-disc{
    list-style-type: disc;
}
 .appearance-none{
    appearance: none;
}
 .grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
 .grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
 .grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
 .grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
}
 .grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
}
 .grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
}
 .flex-col{
    flex-direction: column;
}
 .flex-wrap{
    flex-wrap: wrap;
}
 .items-start{
    align-items: flex-start;
}
 .items-end{
    align-items: flex-end;
}
 .items-center{
    align-items: center;
}
 .justify-start{
    justify-content: flex-start;
}
 .justify-end{
    justify-content: flex-end;
}
 .justify-center{
    justify-content: center;
}
 .justify-between{
    justify-content: space-between;
}
 .justify-items-end{
    justify-items: end;
}
 .gap-1{
    gap: 0.25rem;
}
 .gap-12{
    gap: 3rem;
}
 .gap-2{
    gap: 0.5rem;
}
 .gap-2\\.5{
    gap: 0.625rem;
}
 .gap-3{
    gap: 0.75rem;
}
 .gap-3\\.5{
    gap: 0.875rem;
}
 .gap-4{
    gap: 1rem;
}
 .gap-4\\.5{
    gap: 1.125rem;
}
 .gap-5{
    gap: 1.25rem;
}
 .gap-6{
    gap: 1.5rem;
}
 .gap-8{
    gap: 2rem;
}
 .space-x-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
 .space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
 .space-x-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
 .space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
 .space-x-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
 .space-y-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
 .space-y-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
 .space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
 .space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
 .space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
 .space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
 .space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
 .divide-y > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
 .divide-gray-100 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
 .divide-gray-200 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
 .overflow-auto{
    overflow: auto;
}
 .overflow-hidden{
    overflow: hidden;
}
 .overflow-visible{
    overflow: visible;
}
 .overflow-x-auto{
    overflow-x: auto;
}
 .overflow-y-auto{
    overflow-y: auto;
}
 .overflow-x-hidden{
    overflow-x: hidden;
}
 .overflow-y-scroll{
    overflow-y: scroll;
}
 .truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
 .text-ellipsis{
    text-overflow: ellipsis;
}
 .whitespace-nowrap{
    white-space: nowrap;
}
 .whitespace-pre-wrap{
    white-space: pre-wrap;
}
 .text-wrap{
    text-wrap: wrap;
}
 .break-words{
    overflow-wrap: break-word;
}
 .break-all{
    word-break: break-all;
}
 .rounded{
    border-radius: 0.25rem;
}
 .rounded-2xl{
    border-radius: 1rem;
}
 .rounded-full{
    border-radius: 9999px;
}
 .rounded-lg{
    border-radius: 0.5rem;
}
 .rounded-md{
    border-radius: 0.375rem;
}
 .rounded-sm{
    border-radius: 0.125rem;
}
 .rounded-xl{
    border-radius: 0.75rem;
}
 .rounded-b-lg{
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}
 .rounded-t-lg{
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
 .border{
    border-width: 1px;
}
 .border-0{
    border-width: 0px;
}
 .border-2{
    border-width: 2px;
}
 .border-4{
    border-width: 4px;
}
 .border-b{
    border-bottom-width: 1px;
}
 .border-b-2{
    border-bottom-width: 2px;
}
 .border-l-4{
    border-left-width: 4px;
}
 .border-r{
    border-right-width: 1px;
}
 .border-r-4{
    border-right-width: 4px;
}
 .border-t{
    border-top-width: 1px;
}
 .border-t-2{
    border-top-width: 2px;
}
 .border-t-4{
    border-top-width: 4px;
}
 .border-solid{
    border-style: solid;
}
 .border-dashed{
    border-style: dashed;
}
 .border-amber-200{
    --tw-border-opacity: 1;
    border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
 .border-blue-200{
    --tw-border-opacity: 1;
    border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
 .border-blue-500{
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
 .border-blue-600{
    --tw-border-opacity: 1;
    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
 .border-border{
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
 .border-border2{
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
 .border-border3{
    --tw-border-opacity: 1;
    border-color: rgb(238 238 238 / var(--tw-border-opacity, 1));
}
 .border-fontColor{
    --tw-border-opacity: 1;
    border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
 .border-gray-100{
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
 .border-gray-200{
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
 .border-gray-300{
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
 .border-gray-400{
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
 .border-gray-500{
    --tw-border-opacity: 1;
    border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
 .border-green-200{
    --tw-border-opacity: 1;
    border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
 .border-green-300{
    --tw-border-opacity: 1;
    border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
 .border-green-500{
    --tw-border-opacity: 1;
    border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
 .border-imageBorder{
    --tw-border-opacity: 1;
    border-color: rgb(0 150 216 / var(--tw-border-opacity, 1));
}
 .border-orange-500{
    --tw-border-opacity: 1;
    border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
 .border-red-200{
    --tw-border-opacity: 1;
    border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
 .border-red-300{
    --tw-border-opacity: 1;
    border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
 .border-red-600{
    --tw-border-opacity: 1;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
 .border-red-800{
    --tw-border-opacity: 1;
    border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
 .border-rose-600{
    --tw-border-opacity: 1;
    border-color: rgb(225 29 72 / var(--tw-border-opacity, 1));
}
 .border-transparent{
    border-color: transparent;
}
 .border-white{
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
 .border-yellow-200{
    --tw-border-opacity: 1;
    border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
 .border-b-blue-300{
    --tw-border-opacity: 1;
    border-bottom-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
 .border-b-blue-500{
    --tw-border-opacity: 1;
    border-bottom-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
 .border-t-blue-600{
    --tw-border-opacity: 1;
    border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
 .border-t-gray-800{
    --tw-border-opacity: 1;
    border-top-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
 .border-t-transparent{
    border-top-color: transparent;
}
 .border-opacity-60{
    --tw-border-opacity: 0.6;
}
 .bg-\\[\\#fafafa\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
 .bg-amber-50{
    --tw-bg-opacity: 1;
    background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
 .bg-black{
    --tw-bg-opacity: 1;
    background-color: rgb(28 36 52 / var(--tw-bg-opacity, 1));
}
 .bg-black\\/40{
    background-color: rgb(28 36 52 / 0.4);
}
 .bg-black\\/60{
    background-color: rgb(28 36 52 / 0.6);
}
 .bg-blue-100{
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
 .bg-blue-200{
    --tw-bg-opacity: 1;
    background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
 .bg-blue-300{
    --tw-bg-opacity: 1;
    background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
 .bg-blue-400{
    --tw-bg-opacity: 1;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
 .bg-blue-50{
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
 .bg-blue-500{
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
 .bg-blue-600{
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
 .bg-cyan-100{
    --tw-bg-opacity: 1;
    background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
 .bg-emerald-100{
    --tw-bg-opacity: 1;
    background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
 .bg-emerald-600{
    --tw-bg-opacity: 1;
    background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
 .bg-gray-100{
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
 .bg-gray-200{
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
 .bg-gray-300{
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
 .bg-gray-400{
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
 .bg-gray-50{
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
 .bg-gray-500{
    --tw-bg-opacity: 1;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
 .bg-gray-600{
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
 .bg-gray-700{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
 .bg-gray-800{
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
 .bg-green-100{
    --tw-bg-opacity: 1;
    background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
 .bg-green-200{
    --tw-bg-opacity: 1;
    background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
 .bg-green-300{
    --tw-bg-opacity: 1;
    background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}
 .bg-green-400{
    --tw-bg-opacity: 1;
    background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
 .bg-green-50{
    --tw-bg-opacity: 1;
    background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
 .bg-green-500{
    --tw-bg-opacity: 1;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
 .bg-green-600{
    --tw-bg-opacity: 1;
    background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
 .bg-iconBg{
    --tw-bg-opacity: 1;
    background-color: rgb(0 150 216 / var(--tw-bg-opacity, 1));
}
 .bg-indigo-100{
    --tw-bg-opacity: 1;
    background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
 .bg-loginBg{
    --tw-bg-opacity: 1;
    background-color: rgb(0 150 216 / var(--tw-bg-opacity, 1));
}
 .bg-logoutBg{
    --tw-bg-opacity: 1;
    background-color: rgb(254 35 111 / var(--tw-bg-opacity, 1));
}
 .bg-mainBg{
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
 .bg-meta-1{
    --tw-bg-opacity: 1;
    background-color: rgb(220 53 69 / var(--tw-bg-opacity, 1));
}
 .bg-orange-100{
    --tw-bg-opacity: 1;
    background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
 .bg-orange-200{
    --tw-bg-opacity: 1;
    background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
 .bg-orange-400{
    --tw-bg-opacity: 1;
    background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
 .bg-pink-100{
    --tw-bg-opacity: 1;
    background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
 .bg-primary{
    --tw-bg-opacity: 1;
    background-color: rgb(119 192 221 / var(--tw-bg-opacity, 1));
}
 .bg-purple-100{
    --tw-bg-opacity: 1;
    background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
 .bg-purple-400{
    --tw-bg-opacity: 1;
    background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
 .bg-purple-500{
    --tw-bg-opacity: 1;
    background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
 .bg-purple-600{
    --tw-bg-opacity: 1;
    background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
 .bg-red-100{
    --tw-bg-opacity: 1;
    background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
 .bg-red-200{
    --tw-bg-opacity: 1;
    background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
 .bg-red-300{
    --tw-bg-opacity: 1;
    background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
 .bg-red-400{
    --tw-bg-opacity: 1;
    background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
 .bg-red-50{
    --tw-bg-opacity: 1;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
 .bg-red-500{
    --tw-bg-opacity: 1;
    background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
 .bg-red-600{
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
 .bg-red-700{
    --tw-bg-opacity: 1;
    background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
 .bg-rose-500{
    --tw-bg-opacity: 1;
    background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
 .bg-slate-200{
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
 .bg-tableBg{
    --tw-bg-opacity: 1;
    background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1));
}
 .bg-tableHeadBg{
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
 .bg-transparent{
    background-color: transparent;
}
 .bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
 .bg-white\\/50{
    background-color: rgb(255 255 255 / 0.5);
}
 .bg-yellow-100{
    --tw-bg-opacity: 1;
    background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
 .bg-yellow-200{
    --tw-bg-opacity: 1;
    background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
 .bg-yellow-300{
    --tw-bg-opacity: 1;
    background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
 .bg-yellow-50{
    --tw-bg-opacity: 1;
    background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
 .bg-opacity-30{
    --tw-bg-opacity: 0.3;
}
 .bg-opacity-5{
    --tw-bg-opacity: 0.05;
}
 .bg-opacity-50{
    --tw-bg-opacity: 0.5;
}
 .bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
 .bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
 .bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
 .from-blue-300{
    --tw-gradient-from: #93c5fd var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(147 197 253 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
 .from-blue-50{
    --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
 .from-blue-500{
    --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
 .via-gray-300{
    --tw-gradient-to: rgb(209 213 219 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), #d1d5db var(--tw-gradient-via-position), var(--tw-gradient-to);
}
 .to-blue-300{
    --tw-gradient-to: #93c5fd var(--tw-gradient-to-position);
}
 .to-blue-600{
    --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
 .to-indigo-100{
    --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
 .to-indigo-50{
    --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
 .fill-current{
    fill: currentColor;
}
 .fill-red-500{
    fill: #ef4444;
}
 .fill-yellow-500{
    fill: #eab308;
}
 .object-contain{
    object-fit: contain;
}
 .object-cover{
    object-fit: cover;
}
 .p-0{
    padding: 0px;
}
 .p-1{
    padding: 0.25rem;
}
 .p-1\\.5{
    padding: 0.375rem;
}
 .p-2{
    padding: 0.5rem;
}
 .p-2\\.5{
    padding: 0.625rem;
}
 .p-3{
    padding: 0.75rem;
}
 .p-4{
    padding: 1rem;
}
 .p-5{
    padding: 1.25rem;
}
 .p-6{
    padding: 1.5rem;
}
 .p-8{
    padding: 2rem;
}
 .p-\\[0\\.5\\%\\]{
    padding: 0.5%;
}
 .px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
 .px-1\\.5{
    padding-left: 0.375rem;
    padding-right: 0.375rem;
}
 .px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
 .px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}
 .px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
 .px-4{
    padding-left: 1rem;
    padding-right: 1rem;
}
 .px-4\\.5{
    padding-left: 1.125rem;
    padding-right: 1.125rem;
}
 .px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
 .px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
 .px-8{
    padding-left: 2rem;
    padding-right: 2rem;
}
 .py-0\\.5{
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
 .py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
 .py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
 .py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
 .py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
 .py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
}
 .py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}
 .py-7\\.5{
    padding-top: 1.875rem;
    padding-bottom: 1.875rem;
}
 .py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
}
 .py-\\[0\\.5\\]{
    padding-top: 0.5;
    padding-bottom: 0.5;
}
 .py-\\[14px\\]{
    padding-top: 14px;
    padding-bottom: 14px;
}
 .pb-1\\.5{
    padding-bottom: 0.375rem;
}
 .pb-10{
    padding-bottom: 2.5rem;
}
 .pb-16{
    padding-bottom: 4rem;
}
 .pb-3{
    padding-bottom: 0.75rem;
}
 .pb-4{
    padding-bottom: 1rem;
}
 .pb-6{
    padding-bottom: 1.5rem;
}
 .pb-8{
    padding-bottom: 2rem;
}
 .pl-10{
    padding-left: 2.5rem;
}
 .pl-2{
    padding-left: 0.5rem;
}
 .pl-3{
    padding-left: 0.75rem;
}
 .pl-4{
    padding-left: 1rem;
}
 .pl-5{
    padding-left: 1.25rem;
}
 .pl-6{
    padding-left: 1.5rem;
}
 .pr-10{
    padding-right: 2.5rem;
}
 .pr-2{
    padding-right: 0.5rem;
}
 .pr-3{
    padding-right: 0.75rem;
}
 .pr-4{
    padding-right: 1rem;
}
 .pr-5{
    padding-right: 1.25rem;
}
 .pr-8{
    padding-right: 2rem;
}
 .ps-10{
    padding-inline-start: 2.5rem;
}
 .pt-1{
    padding-top: 0.25rem;
}
 .pt-2{
    padding-top: 0.5rem;
}
 .pt-3{
    padding-top: 0.75rem;
}
 .pt-4{
    padding-top: 1rem;
}
 .pt-6{
    padding-top: 1.5rem;
}
 .text-left{
    text-align: left;
}
 .text-center{
    text-align: center;
}
 .text-right{
    text-align: right;
}
 .text-start{
    text-align: start;
}
 .align-top{
    vertical-align: top;
}
 .font-mono{
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
 .font-sans{
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
 .text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
}
 .text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
}
 .text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
}
 .text-5xl{
    font-size: 3rem;
    line-height: 1;
}
 .text-6xl{
    font-size: 3.75rem;
    line-height: 1;
}
 .text-\\[10px\\]{
    font-size: 10px;
}
 .text-\\[11px\\]{
    font-size: 11px;
}
 .text-\\[12px\\]{
    font-size: 12px;
}
 .text-\\[18px\\]{
    font-size: 18px;
}
 .text-\\[19px\\]{
    font-size: 19px;
}
 .text-\\[22px\\]{
    font-size: 22px;
}
 .text-base{
    font-size: 1rem;
    line-height: 1.5rem;
}
 .text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
}
 .text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
}
 .text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
}
 .text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
}
 .font-bold{
    font-weight: 700;
}
 .font-extrabold{
    font-weight: 800;
}
 .font-medium{
    font-weight: 500;
}
 .font-normal{
    font-weight: 400;
}
 .font-semibold{
    font-weight: 600;
}
 .font-thin{
    font-weight: 100;
}
 .uppercase{
    text-transform: uppercase;
}
 .lowercase{
    text-transform: lowercase;
}
 .capitalize{
    text-transform: capitalize;
}
 .italic{
    font-style: italic;
}
 .leading-5{
    line-height: 1.25rem;
}
 .leading-tight{
    line-height: 1.25;
}
 .tracking-wider{
    letter-spacing: 0.05em;
}
 .text-amber-700{
    --tw-text-opacity: 1;
    color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
 .text-black{
    --tw-text-opacity: 1;
    color: rgb(28 36 52 / var(--tw-text-opacity, 1));
}
 .text-blue-100{
    --tw-text-opacity: 1;
    color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
 .text-blue-500{
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
 .text-blue-600{
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
 .text-blue-700{
    --tw-text-opacity: 1;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
 .text-blue-800{
    --tw-text-opacity: 1;
    color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
 .text-blue-900{
    --tw-text-opacity: 1;
    color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
 .text-bodydark2{
    --tw-text-opacity: 1;
    color: rgb(138 153 175 / var(--tw-text-opacity, 1));
}
 .text-cyan-800{
    --tw-text-opacity: 1;
    color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
 .text-emerald-800{
    --tw-text-opacity: 1;
    color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
 .text-fontBlack{
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
 .text-fontColor{
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
 .text-fontColor\\/80{
    color: rgb(100 116 139 / 0.8);
}
 .text-gray-300{
    --tw-text-opacity: 1;
    color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
 .text-gray-400{
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
 .text-gray-500{
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
 .text-gray-600{
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
 .text-gray-700{
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
 .text-gray-800{
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
 .text-gray-900{
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
 .text-green-500{
    --tw-text-opacity: 1;
    color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
 .text-green-600{
    --tw-text-opacity: 1;
    color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
 .text-green-700{
    --tw-text-opacity: 1;
    color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
 .text-green-800{
    --tw-text-opacity: 1;
    color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
 .text-headColor{
    --tw-text-opacity: 1;
    color: rgb(0 150 216 / var(--tw-text-opacity, 1));
}
 .text-headGrey{
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
 .text-indigo-700{
    --tw-text-opacity: 1;
    color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
 .text-indigo-800{
    --tw-text-opacity: 1;
    color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
 .text-orange-500{
    --tw-text-opacity: 1;
    color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
 .text-orange-600{
    --tw-text-opacity: 1;
    color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
 .text-orange-800{
    --tw-text-opacity: 1;
    color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
 .text-pink-800{
    --tw-text-opacity: 1;
    color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}
 .text-purple-600{
    --tw-text-opacity: 1;
    color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
 .text-purple-800{
    --tw-text-opacity: 1;
    color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
 .text-red-400{
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
 .text-red-500{
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
 .text-red-600{
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
 .text-red-700{
    --tw-text-opacity: 1;
    color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
 .text-red-800{
    --tw-text-opacity: 1;
    color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
 .text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
 .text-yellow-500{
    --tw-text-opacity: 1;
    color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
 .text-yellow-600{
    --tw-text-opacity: 1;
    color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
 .text-yellow-700{
    --tw-text-opacity: 1;
    color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
 .text-yellow-800{
    --tw-text-opacity: 1;
    color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
 .underline{
    text-decoration-line: underline;
}
 .opacity-0{
    opacity: 0;
}
 .opacity-25{
    opacity: 0.25;
}
 .opacity-75{
    opacity: 0.75;
}
 .opacity-80{
    opacity: 0.8;
}
 .shadow{
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-1{
    --tw-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
    --tw-shadow-colored: 0px 1px 3px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-4{
    --tw-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    --tw-shadow-colored: 0px 4px 10px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-6{
    --tw-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
    --tw-shadow-colored: 0px 3px 15px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-8{
    --tw-shadow: 1px 0 0 #313D4A, -1px 0 0 #313D4A, 0 1px 0 #313D4A, 0 -1px 0 #313D4A, 0 3px 13px rgb(0 0 0 / 8%);
    --tw-shadow-colored: 1px 0 0 var(--tw-shadow-color), -1px 0 0 var(--tw-shadow-color), 0 1px 0 var(--tw-shadow-color), 0 -1px 0 var(--tw-shadow-color), 0 3px 13px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-default{
    --tw-shadow: 0px 8px 13px -3px rgba(0, 0, 0, 0.07);
    --tw-shadow-colored: 0px 8px 13px -3px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-lg{
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-sm{
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-switcher{
    --tw-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2), inset 0px 2px 2px #FFFFFF, inset 0px -1px 1px rgba(0, 0, 0, 0.1);
    --tw-shadow-colored: 0px 2px 4px var(--tw-shadow-color), inset 0px 2px 2px var(--tw-shadow-color), inset 0px -1px 1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-xl{
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
 .shadow-iconShadow{
    --tw-shadow-color: #1CA8EA4D;
    --tw-shadow: var(--tw-shadow-colored);
}
 .outline-none{
    outline: 2px solid transparent;
    outline-offset: 2px;
}
 .ring-1{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
 .ring-gray-200{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
 .drop-shadow-lg{
    --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
 .filter{
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
 .backdrop-blur-lg{
    --tw-backdrop-blur: blur(16px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
 .backdrop-blur-md{
    --tw-backdrop-blur: blur(12px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
 .transition{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
 .transition-all{
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
 .transition-colors{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
 .transition-opacity{
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
 .transition-shadow{
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
 .transition-transform{
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
 .duration-200{
    transition-duration: 200ms;
}
 .duration-300{
    transition-duration: 300ms;
}
 .duration-75{
    transition-duration: 75ms;
}
 .ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
 .ease-linear{
    transition-timing-function: linear;
}
 
 .custom-header {
    background-color: #002b4a; /* Set your desired background color */
  }
  .customGridToolbar {
    background-color: #eeeef9; /* Change background color */
    border-bottom: 1px solid #ddd; /* Add border bottom */
    padding: 8px; /* Add padding */
    color: #333; /* Add text color */
    padding-left: 16px; /* Add left padding */
  }
  .file\\:m-3::file-selector-button{
    margin: 0.75rem;
}
  .file\\:h-8::file-selector-button{
    height: 2rem;
}
  .file\\:w-20::file-selector-button{
    width: 5rem;
}
  .file\\:rounded::file-selector-button{
    border-radius: 0.25rem;
}
  .file\\:border::file-selector-button{
    border-width: 1px;
}
  .file\\:border-gray-400::file-selector-button{
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
  .file\\:bg-white::file-selector-button{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
  .file\\:text-xs::file-selector-button{
    font-size: 0.75rem;
    line-height: 1rem;
}
  .file\\:font-semibold::file-selector-button{
    font-weight: 600;
}
  .file\\:text-fontColor::file-selector-button{
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
  .file\\:shadow-none::file-selector-button{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .last\\:border-r-0:last-child{
    border-right-width: 0px;
}
  .odd\\:bg-gray-50:nth-child(odd){
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
  .even\\:bg-white:nth-child(even){
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
  .hover\\:border-2:hover{
    border-width: 2px;
}
  .hover\\:border-b:hover{
    border-bottom-width: 1px;
}
  .hover\\:border-b-2:hover{
    border-bottom-width: 2px;
}
  .hover\\:border-blue-700:hover{
    --tw-border-opacity: 1;
    border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
  .hover\\:border-gray-300:hover{
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
  .hover\\:border-gray-400:hover{
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
  .hover\\:border-b-blue-500:hover{
    --tw-border-opacity: 1;
    border-bottom-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
  .hover\\:bg-black\\/80:hover{
    background-color: rgb(28 36 52 / 0.8);
}
  .hover\\:bg-blue-200:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-blue-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-blue-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-emerald-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-gray-100:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-gray-200:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-gray-300:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-gray-400:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-gray-50:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-gray-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-green-200:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-green-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-green-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-purple-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-purple-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-red-200:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-red-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
  .hover\\:bg-red-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
  .hover\\:text-blue-600:hover{
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
  .hover\\:text-blue-700:hover{
    --tw-text-opacity: 1;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
  .hover\\:text-blue-800:hover{
    --tw-text-opacity: 1;
    color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
  .hover\\:text-blue-900:hover{
    --tw-text-opacity: 1;
    color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
  .hover\\:text-gray-600:hover{
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
  .hover\\:text-gray-700:hover{
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
  .hover\\:text-gray-800:hover{
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
  .hover\\:text-gray-900:hover{
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
  .hover\\:text-green-700:hover{
    --tw-text-opacity: 1;
    color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
  .hover\\:text-green-800:hover{
    --tw-text-opacity: 1;
    color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
  .hover\\:text-headColor:hover{
    --tw-text-opacity: 1;
    color: rgb(0 150 216 / var(--tw-text-opacity, 1));
}
  .hover\\:text-primary:hover{
    --tw-text-opacity: 1;
    color: rgb(119 192 221 / var(--tw-text-opacity, 1));
}
  .hover\\:text-red-600:hover{
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
  .hover\\:text-red-700:hover{
    --tw-text-opacity: 1;
    color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
  .hover\\:text-red-800:hover{
    --tw-text-opacity: 1;
    color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
  .hover\\:text-red-900:hover{
    --tw-text-opacity: 1;
    color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
  .hover\\:underline:hover{
    text-decoration-line: underline;
}
  .hover\\:opacity-70:hover{
    opacity: 0.7;
}
  .hover\\:opacity-90:hover{
    opacity: 0.9;
}
  .hover\\:shadow-md:hover{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .focus\\:border-blue-500:focus{
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
  .focus\\:border-gray-400:focus{
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
  .focus\\:border-indigo-500:focus{
    --tw-border-opacity: 1;
    border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
  .focus\\:border-transparent:focus{
    border-color: transparent;
}
  .focus\\:outline-none:focus{
    outline: 2px solid transparent;
    outline-offset: 2px;
}
  .focus\\:ring:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  .focus\\:ring-1:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  .focus\\:ring-2:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  .focus\\:ring-blue-200:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-blue-400:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-blue-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-gray-400:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-gray-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-green-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-indigo-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-primary:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(119 192 221 / var(--tw-ring-opacity, 1));
}
  .focus\\:ring-offset-2:focus{
    --tw-ring-offset-width: 2px;
}
  .disabled\\:cursor-not-allowed:disabled{
    cursor: not-allowed;
}
  .disabled\\:bg-blue-200:disabled{
    --tw-bg-opacity: 1;
    background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
  .disabled\\:bg-blue-400:disabled{
    --tw-bg-opacity: 1;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
  .disabled\\:bg-gray-400:disabled{
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
  .disabled\\:opacity-50:disabled{
    opacity: 0.5;
}
  .group:hover .group-hover\\:block{
    display: block;
}
  .group:hover .group-hover\\:opacity-100{
    opacity: 1;
}
  .dark\\:inline-block:is(.dark *){
    display: inline-block;
}
  .dark\\:hidden:is(.dark *){
    display: none;
}
  .dark\\:border-strokedark:is(.dark *){
    --tw-border-opacity: 1;
    border-color: rgb(46 58 71 / var(--tw-border-opacity, 1));
}
  .dark\\:bg-boxdark:is(.dark *){
    --tw-bg-opacity: 1;
    background-color: rgb(36 48 63 / var(--tw-bg-opacity, 1));
}
  .dark\\:bg-meta-4:is(.dark *){
    --tw-bg-opacity: 1;
    background-color: rgb(49 61 74 / var(--tw-bg-opacity, 1));
}
  .dark\\:text-gray-200:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
  .dark\\:text-gray-400:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
  .dark\\:text-white:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  .dark\\:hover\\:bg-meta-4:hover:is(.dark *){
    --tw-bg-opacity: 1;
    background-color: rgb(49 61 74 / var(--tw-bg-opacity, 1));
}
  .dark\\:hover\\:text-black:hover:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(28 36 52 / var(--tw-text-opacity, 1));
}
  @media (min-width: 375px){
    .\\32xsm\\:gap-4{
        gap: 1rem;
    }
}
  @media (min-width: 640px){
    .sm\\:right-0{
        right: 0px;
    }
    .sm\\:w-80{
        width: 20rem;
    }
    .sm\\:flex-row{
        flex-direction: row;
    }
    .sm\\:px-6{
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
    .sm\\:text-sm{
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
}
  @media (min-width: 768px){
    .md\\:static{
        position: static;
    }
    .md\\:col-span-2{
        grid-column: span 2 / span 2;
    }
    .md\\:mb-6{
        margin-bottom: 1.5rem;
    }
    .md\\:flex{
        display: flex;
    }
    .md\\:max-h-96{
        max-height: 24rem;
    }
    .md\\:w-1\\/3{
        width: 33.333333%;
    }
    .md\\:w-2\\/3{
        width: 66.666667%;
    }
    .md\\:w-64{
        width: 16rem;
    }
    .md\\:grid-cols-2{
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:grid-cols-3{
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-cols-4{
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .md\\:flex-row{
        flex-direction: row;
    }
    .md\\:items-center{
        align-items: center;
    }
    .md\\:justify-between{
        justify-content: space-between;
    }
    .md\\:gap-6{
        gap: 1.5rem;
    }
    .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
        --tw-space-y-reverse: 0;
        margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0px * var(--tw-space-y-reverse));
    }
    .md\\:p-3{
        padding: 0.75rem;
    }
    .md\\:p-6{
        padding: 1.5rem;
    }
    .md\\:px-6{
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
    .md\\:text-base{
        font-size: 1rem;
        line-height: 1.5rem;
    }
    .md\\:text-sm{
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
    .md\\:text-xl{
        font-size: 1.25rem;
        line-height: 1.75rem;
    }
}
  @media (min-width: 1024px){
    .lg\\:mx-6{
        margin-left: 1.5rem;
        margin-right: 1.5rem;
    }
    .lg\\:block{
        display: block;
    }
    .lg\\:w-1\\/4{
        width: 25%;
    }
    .lg\\:grid-cols-1{
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .lg\\:grid-cols-3{
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-4{
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:grid-cols-5{
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .lg\\:flex-row{
        flex-direction: row;
    }
    .lg\\:px-8{
        padding-left: 2rem;
        padding-right: 2rem;
    }
    .lg\\:text-base{
        font-size: 1rem;
        line-height: 1.5rem;
    }
}
  @media (min-width: 1280px){
    .xl\\:max-w-screen-xl{
        max-width: 1280px;
    }
    .xl\\:grid-cols-2{
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
  @media (min-width: 1536px){
    .\\32xl\\:max-w-screen-2xl{
        max-width: 1536px;
    }
    .\\32xl\\:px-11{
        padding-left: 2.75rem;
        padding-right: 2.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE;CACD,wFAAwF;CACxF,8FAA8F;CAE9F;;;GAGE;EACD;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;CACD;KACI,SAAS;KACT,UAAU;KACV,mCAAmC;CACvC;;CAEA;;GAEE;CACF;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;CAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;CAAd;EAAc;CAAd;;;CAAc;CAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;CAAd;;EAAA,gBAAc;AAAA;CAAd;;;;;;;;CAAc;CAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;CAAd;;;CAAc;CAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;CAAd;;;;CAAc;CAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,iCAAc;AAAA;CAAd;;CAAc;CAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;CAAd;;CAAc;CAAd;;EAAA,mBAAc;AAAA;CAAd;;;;;CAAc;CAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,cAAc;AAAA;CAAd;;CAAc;CAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;CAAd;EAAA,eAAc;AAAA;CAAd;EAAA,WAAc;AAAA;CAAd;;;;CAAc;CAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;CAAd;;;;CAAc;CAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;;EAAA,oBAAc;AAAA;CAAd;;;CAAc;CAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,aAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,gBAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,wBAAc;AAAA;CAAd;;CAAc;CAAd;;EAAA,YAAc;AAAA;CAAd;;;CAAc;CAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,wBAAc;AAAA;CAAd;;;CAAc;CAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,kBAAc;AAAA;CAAd;;CAAc;CAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;CAAd;EAAA,SAAc;EAAd,UAAc;AAAA;CAAd;EAAA,UAAc;AAAA;CAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,UAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,gBAAc;AAAA;CAAd;;;CAAc;CAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;;EAAA,eAAc;AAAA;CAAd;;CAAc;CAAd;EAAA,eAAc;AAAA;CAAd;;;;CAAc;CAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;CAAd;;CAAc;CAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;CAAd,wEAAc;CAAd;EAAA,aAAc;AAAA;CAEd;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,QAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,iBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,iBAAmB;IAAnB;AAAmB;CAAnB;IAAA,gBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,iCAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;QAAA,mBAAmB;QAAnB;IAAmB;AAAA;CAAnB;IAAA;AAAmB;CAAnB;IAAA;QAAA;IAAmB;AAAA;CAAnB;IAAA;AAAmB;CAAnB;IAAA;QAAA;IAAmB;AAAA;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,yBAAmB;YAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,oDAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;CAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;CAAnB;IAAA,wBAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,kCAAmB;IAAnB;AAAmB;CAAnB;IAAA,8BAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,4DAAmB;IAAnB,qEAAmB;IAAnB;AAAmB;CAAnB;IAAA,4DAAmB;IAAnB,qEAAmB;IAAnB;AAAmB;CAAnB;IAAA,4DAAmB;IAAnB,oEAAmB;IAAnB;AAAmB;CAAnB;IAAA,sEAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,iBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,qBAAmB;IAAnB;AAAmB;CAAnB;IAAA,iBAAmB;IAAnB;AAAmB;CAAnB;IAAA,gBAAmB;IAAnB;AAAmB;CAAnB;IAAA,iBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,iBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,eAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,eAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA,kBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;CAAnB;IAAA,4CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;CAAnB;IAAA,6CAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,4CAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,6GAAmB;IAAnB,wLAAmB;IAAnB;AAAmB;CAAnB;IAAA,kDAAmB;IAAnB,6DAAmB;IAAnB;AAAmB;CAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;CAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;CAAnB;IAAA,sBAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;CAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;CAAnB;IAAA,6GAAmB;IAAnB,4IAAmB;IAAnB;AAAmB;CAAnB;IAAA,gFAAmB;IAAnB,oGAAmB;IAAnB;AAAmB;CAAnB;IAAA,4BAAmB;IAAnB;AAAmB;CAAnB;IAAA,8BAAmB;IAAnB;AAAmB;CAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;CAAnB;IAAA,oBAAmB;IAAnB;AAAmB;CAAnB;IAAA,mGAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA,8BAAmB;IAAnB;AAAmB;CAAnB;IAAA,8BAAmB;IAAnB;AAAmB;CAAnB;IAAA,wJAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,4BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,+BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;CAAnB;IAAA;AAAmB;;CAEnB;IACG,yBAAyB,EAAE,sCAAsC;EACnE;EACA;IACE,yBAAyB,EAAE,4BAA4B;IACvD,6BAA6B,EAAE,sBAAsB;IACrD,YAAY,EAAE,gBAAgB;IAC9B,WAAW,EAAE,mBAAmB;IAChC,kBAAkB,EAAE,qBAAqB;EAC3C;EArCF;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH,8BAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,6EAqCG;IArCH,iGAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,8BAqCG;IArCH;AAqCG;EArCH;IAAA,2GAqCG;IArCH,yGAqCG;IArCH;AAqCG;EArCH;IAAA,2GAqCG;IArCH,yGAqCG;IArCH;AAqCG;EArCH;IAAA,2GAqCG;IArCH,yGAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA;AAqCG;EArCH;IAAA,sBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA,kBAqCG;IArCH;AAqCG;EArCH;IAAA,oBAqCG;IArCH;AAqCG;EArCH;IAAA;QAAA;IAqCG;AAAA;EArCH;IAAA;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA,oBAqCG;QArCH;IAqCG;IArCH;QAAA,mBAqCG;QArCH;IAqCG;AAAA;EArCH;IAAA;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA,uBAqCG;QArCH,2DAqCG;QArCH;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA,oBAqCG;QArCH;IAqCG;IArCH;QAAA,eAqCG;QArCH;IAqCG;IArCH;QAAA,mBAqCG;QArCH;IAqCG;IArCH;QAAA,kBAqCG;QArCH;IAqCG;AAAA;EArCH;IAAA;QAAA,mBAqCG;QArCH;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA;IAqCG;IArCH;QAAA,kBAqCG;QArCH;IAqCG;IArCH;QAAA,eAqCG;QArCH;IAqCG;AAAA;EArCH;IAAA;QAAA;IAqCG;IArCH;QAAA;IAqCG;AAAA;EArCH;IAAA;QAAA;IAqCG;IArCH;QAAA,qBAqCG;QArCH;IAqCG;AAAA","sourcesContent":["/**\n * Importing the Google Fonts 'Open Sans' with multiple weights for the body text\n */\n /* @import url('https://fonts.google.com/share?selection.family=Inter:wght@100..900'); */\n /* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap'); */\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:wght@100..900&display=swap');\n /**\n  * Resetting default margin and padding for the body\n  * Setting the font family for the entire document to 'Inter', falling back to the default sans-serif font\n  */\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n body {\n     margin: 0;\n     padding: 0;\n     font-family: \"Inter\" , \"sans-serif\";\n }\n \n /**\n  * Importing Tailwind CSS base, components, and utilities\n  */\n @tailwind base;\n @tailwind components;\n @tailwind utilities;\n \n .custom-header {\n    background-color: #002b4a; /* Set your desired background color */\n  }\n  .customGridToolbar {\n    background-color: #eeeef9; /* Change background color */\n    border-bottom: 1px solid #ddd; /* Add border bottom */\n    padding: 8px; /* Add padding */\n    color: #333; /* Add text color */\n    padding-left: 16px; /* Add left padding */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
